<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="
                  [
                    {
                      title: 'Dashboard',
                      url: 'dashboard'
                    },
                    {
                      title: 'Link 1',
                      url: 'link-1'
                    },
                    {
                      title: 'Link 2',
                      disabled: true
                    },
                    {
                      title: 'Active',
                      active: true
                    }
                  ]"
              ></vs-breadcrumb>
              <div class="frm-title">
                <div class="heading mt-3">
                  <h3
                    class="text-secondary"
                    style="font-size:20px;margin-bottom:0px"
                  >Funding Agency Information</h3>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead style="background:#06a6e0">
                    <tr class="text-white">
                      <th>Event Title</th>
                      <th>Advisor</th>
                      <th>Subprogram</th>
                      <th>End Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>In global training for prevention techniques against drug & dealers</td>
                      <td>Mohammad Ali Akhtar</td>
                      <td>3-5-2019</td>
                      <td>8-5-2019</td>
                    </tr>
                    <tr>
                      <td>prevention techniques against drug & dealers</td>
                      <td>Usama Khan</td>
                      <td>7-9-2019</td>
                      <td>12-9-2019</td>
                    </tr>
                    <tr>
                      <td>prevention techniques against streets Crime</td>
                      <td>Zeeshan rafiq</td>
                      <td>8-8-2019</td>
                      <td>8-8-2019</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
export default {
  data: () => ({
    isSidebar: false
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
</style>



